import { AppNS } from 'app';
import { getHourFormatted, parseTimeTo } from 'app/helpers/parseDate';
import { getDateFormatted } from 'app/ui/modules/job-events/eventsHelper';

export const prepareInvoiceData = (
  bookingId: string,
  eventReports: Array<AppNS.ProjectEventListItem>,
  invoiceDate: string,
  dueDate: string,
  invoiceNumber: string,
  documentIds: Array<string>,
  scope: string,
  amountForClient: number
): AppNS.Params => {
  return {
    properties: {
      eventReportIds: eventReports.map(
        (item: AppNS.ProjectEventListItem) => item.id || ''
      ),
      bookingId,
      documentIds,
      scope,
      amountForClient,
      invoiceDate,
      dueDate,
      ...(invoiceNumber && { invoiceNumber }),
    },
  };
};

export const prepareInvoicePayData = (
  id: string,
  paymentMethodId: string
): AppNS.Params => {
  return {
    id,
    paymentMethodId,
  };
};

export const parseInvoiceData = (item: AppNS.Params): AppNS.ProjectInvoice => {
  return {
    ...item,
    lineItems: parseInvoiceLineItemsData(item.invoiceLineItems),
  } as AppNS.ProjectInvoice;
};

export const parseInvoiceLineItemsData = (
  items: Array<AppNS.Params>
): Array<AppNS.InvoiceLineItem> => {
  return items.map((item): AppNS.InvoiceLineItem => {
    return {
      id: item.id,
      reportId: item.eventReportId,
      timeSpan: `${getHourFormatted(
        item.eventReport.timeFrom
      )} - ${getHourFormatted(parseTimeTo(item.eventReport.timeTo))}`,
      inspectionDate: getDateFormatted(item.eventReport.date),
      amountForAgency: item.eventReport.amountForAgency,
      amountForClient: item.eventReport.amountForClient,
    };
  });
};
